import { Mutator } from 'final-form'
import { MetaPath } from 'util/metaPath'

import { resolveName } from '../core/hooks/useField'

type Callback = any | ((prevValue: any) => void)

const changeValue: Mutator<any> = (args, state, { changeValue: mutateValue }) => {
  const [name, callback] = args as [MetaPath<any>, Callback]
  const resolveCallback = typeof callback === 'function' ? callback : () => callback

  mutateValue(state, resolveName(name), resolveCallback)
}

export default changeValue
